var _style, _g, _g2, _g3, _g4, _path, _g5, _path2, _g6, _path3, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocengineIllustrationVerticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 1180,
    viewBox: "0 0 360 1180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.s0 { fill: #b7c0cc }\n\t\t.s1 { fill: #e8edf3 }\n\t\t.s2 { fill: none;stroke: #a6b2c2;stroke-width: 4 }\n\t\t.t3 { font-size: 13px;fill: #45556d;font-family: \"DMSans\", sans-serif }\n\t\t.s4 { fill: #fff1e8 }\n\t\t.s5 { fill: none;stroke: #a27a5f;stroke-linecap: round;stroke-linejoin: round;stroke-width: 5 }\n\t\t.s6 { fill: #cdb8a8 }\n\t\t.s7 { fill: #a27a5f }\n\t\t.s8 { fill: #d9dee5 }\n\t\t.s9 { fill: none;stroke: #a6b2c2;stroke-linecap: round;stroke-width: 5 }\n\t\t.t10 { font-size: 13px;fill: #a27a5f;font-family: \"DMSans\", sans-serif }\n\t\t.s11 { fill: #45556d }\n\t\t.s12 { fill: none;stroke: #ffffff;stroke-linecap: round;stroke-width: 8.3 }\n\t\t.s13 { fill: #ffffff }\n\t\t.s14 { fill: #a6b2c2 }\n\t\t.s15 { fill: none;stroke: #cdb8a8;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 }\n\t\t.s16 { fill: none;stroke: #cdb8a8;stroke-linecap: round;stroke-width: 4 }\n\t\t.s17 { fill: #dce8f0 }\n\t\t.s18 { fill: none;stroke: #cdb8a8;stroke-linecap: round;stroke-width: 5 }\n\t\t.s19 { fill: #deeee2 }\n\t\t.s20 { fill: none;stroke: #357653;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3 }\n\t\t.t21 { font-size: 12px;fill: #357653;font-family: \"DMSans\", sans-serif }\n\t\t.s22 { fill: none;stroke: #a6b2c2;stroke-linecap: round;stroke-width: 6 }\n\t\t.s23 { fill: none;stroke: #a6b2c2;stroke-linecap: round;stroke-width: 4 }\n\t\t.s24 { fill: #000000;stroke: #a6b2c2;stroke-linecap: round;stroke-width: 4 }\n\t\t.s25 { fill: #000000;stroke: #357653;stroke-linecap: round;stroke-width: 4 }\n\t\t.s26 { fill: #357653 }\n\t\t.s27 { fill: none;stroke: #cdb8a8;stroke-linecap: round;stroke-width: 3 }\n\t\t.s28 { fill: none;stroke: #a27a5f;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 }\n\t\t.s29 { fill: #000000;stroke: #cdb8a8;stroke-linecap: round;stroke-width: 5 }\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-input",
    transform: "translate(-10 -25)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m28.09 50.35l59.67-6.28c4.95-0.52 9.37 3.07 9.89 8.01l8.99 85.53c0.52 4.95-3.06 9.37-8.01 9.89l-59.67 6.28c-4.94 0.51-9.37-3.07-9.89-8.01l-8.99-85.53c-0.52-4.95 3.07-9.38 8.01-9.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m37.67 74.48l44.75-4.71m-43.19 19.62l34.81-3.65m-33.24 18.57l41.77-4.39"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m80.23 50.04l63.76 5.58c4.95 0.43 8.61 4.8 8.18 9.75l-7.84 89.66c-0.44 4.95-4.8 8.61-9.75 8.18l-63.76-5.58c-4.95-0.43-8.61-4.8-8.18-9.75l7.84-89.66c0.44-4.95 4.8-8.61 9.75-8.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m87.02 75.73l46.82 4.1m-48.13 10.84l36.86 3.23m-38.16 11.72l43.83 3.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m93.38 123.47l25.9 2.26c6.33 0.56 11.01 6.13 10.46 12.46-0.55 6.33-6.13 11.01-12.46 10.46l-25.9-2.27c-6.33-0.55-11.01-6.13-10.45-12.46 0.55-6.33 6.13-11.01 12.45-10.45z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "matrix(.996 .087 -.087 .996 92.291 139.434)",
    x: 0,
    y: 0,
    fontFamily: "DMSans, Arial, sans-serif",
    fontSize: 13,
    fill: "#a27a5f"
  }, "PDF")), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m154.5 92c-10.23 0-18.5-8.27-18.5-18.5 0-10.23 8.27-18.5 18.5-18.5 10.23 0 18.5 8.27 18.5 18.5 0 10.23-8.27 18.5-18.5 18.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer copy 11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m157.42 62.28l1.41 0.42c0.52 0.16 0.81 0.7 0.66 1.22l-0.98 3.29c-0.16 0.52-0.7 0.81-1.22 0.66l-1.41-0.42c-0.52-0.16-0.81-0.7-0.66-1.22l0.98-3.29c0.16-0.52 0.7-0.81 1.22-0.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m152.24 79.66l1.4 0.42c0.52 0.15 0.82 0.7 0.66 1.22l-0.98 3.28c-0.15 0.52-0.7 0.82-1.22 0.66l-1.41-0.42c-0.51-0.15-0.81-0.7-0.66-1.22l0.99-3.29c0.15-0.51 0.7-0.81 1.22-0.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m144.92 69.03l3.29 0.99c0.52 0.15 0.81 0.7 0.66 1.22l-0.42 1.4c-0.16 0.52-0.7 0.82-1.22 0.66l-3.29-0.98c-0.52-0.15-0.81-0.7-0.66-1.22l0.42-1.41c0.16-0.51 0.7-0.81 1.22-0.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m162.3 74.22l3.28 0.98c0.52 0.16 0.82 0.7 0.66 1.22l-0.42 1.41c-0.15 0.52-0.7 0.81-1.22 0.66l-3.29-0.98c-0.51-0.16-0.81-0.7-0.65-1.22l0.42-1.41c0.15-0.52 0.7-0.81 1.22-0.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m164.76 67.52l0.7 1.3c0.26 0.47 0.08 1.07-0.4 1.33l-3.02 1.63c-0.47 0.25-1.07 0.08-1.32-0.4l-0.7-1.29c-0.26-0.48-0.08-1.07 0.39-1.33l3.02-1.63c0.48-0.26 1.07-0.08 1.33 0.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m148.81 76.14l0.7 1.3c0.25 0.47 0.08 1.07-0.4 1.32l-3.02 1.64c-0.47 0.25-1.07 0.08-1.33-0.4l-0.7-1.29c-0.25-0.48-0.08-1.08 0.4-1.33l3.02-1.63c0.48-0.26 1.07-0.08 1.33 0.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m151.15 63.46l1.63 3.02c0.25 0.48 0.08 1.07-0.4 1.33l-1.29 0.7c-0.48 0.25-1.07 0.08-1.33-0.4l-1.63-3.02c-0.26-0.47-0.08-1.07 0.39-1.33l1.3-0.7c0.47-0.25 1.07-0.08 1.33 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m159.76 79.41l1.64 3.02c0.25 0.48 0.08 1.07-0.4 1.33l-1.29 0.7c-0.48 0.26-1.08 0.08-1.33-0.4l-1.63-3.02c-0.26-0.47-0.08-1.07 0.39-1.32l1.3-0.7c0.47-0.26 1.07-0.08 1.32 0.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m152.38 81.74c-4.42-1.31-6.92-5.95-5.6-10.36 1.32-4.42 5.95-6.92 10.36-5.6 4.42 1.32 6.92 5.95 5.6 10.36-1.31 4.42-5.95 6.92-10.36 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m153.85 76.81c-1.69-0.5-2.64-2.27-2.14-3.96 0.5-1.69 2.27-2.64 3.96-2.14 1.69 0.5 2.65 2.27 2.14 3.96-0.5 1.69-2.27 2.65-3.96 2.14z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PDF production ",
    transform: "translate(93,184)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -49.6,
    y: 0,
    className: "t3"
  }, "PDF production\n")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "database-input",
    transform: "translate(25 10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m233 35c-26.54 0-48-5.81-48-13 0-7.19 21.46-13 48-13 26.54 0 48 5.81 48 13 0 7.19-21.46 13-48 13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m185 22v76c0 8 21 14 48 14 27 0 48-6 48-14v-76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m185 47c0 8 21 14 48 14 27 0 48-6 48-14m-96 25c0 8 21 14 48 14 27 0 48-6 48-14m-96 25c0 8 21 14 48 14 27 0 48-6 48-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m233 35c-26.54 0-48-5.81-48-13 0-7.19 21.46-13 48-13 26.54 0 48 5.81 48 13 0 7.19-21.46 13-48 13z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Database ",
    transform: "translate(233,131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31,
    y: 0,
    className: "t3"
  }, "Database\n"))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "transactions-input",
    transform: "translate(-5 -40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m57 221h78c6.63 0 12 5.37 12 12v72c0 6.63-5.37 12-12 12h-78c-6.63 0-12-5.37-12-12v-72c0-6.63 5.37-12 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m96.48 253.4h-36.48m0 0l11.4-11.4m-11.4 11.4l11.4 11.4m25.08 22.8h36.48m0 0l-11.4-11.4m11.4 11.4l-11.4 11.4"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Transactions ",
    transform: "translate(96,338.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40.6,
    y: 0,
    className: "t3"
  }, "Transactions\n"))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "archive-input",
    transform: "translate(25 20)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m159.01 168.65l14.74-13.99 99.1 0.05 14.88 14.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m173.82 173.82l99.27 0.06c7.31 0 13.23 6.65 13.23 14.84l-0.03 46.63c0 8.19-5.93 14.83-13.24 14.83l-99.26-0.06c-7.31 0-13.24-6.65-13.23-14.84l0.02-46.63c0.01-8.19 5.93-14.83 13.24-14.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m163.43 166.25l120.06 0.07c4.7 0 8.51 3.82 8.5 8.51v9.46c0 4.7-3.82 8.5-8.51 8.5l-120.07-0.07c-4.69 0-8.5-3.81-8.5-8.51l0.01-9.45c0-4.7 3.81-8.51 8.51-8.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m209.26 204.09l28.36 0.02c4.44 0 8.03 3.6 8.03 8.04 0 4.44-3.6 8.03-8.04 8.03l-28.36-0.02c-4.44 0-8.03-3.6-8.03-8.04 0-4.43 3.6-8.03 8.04-8.03z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Archive ",
    transform: "translate(223.5,270)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.3,
    y: 0,
    className: "t3"
  }, "Archive\n")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 313v17q0 12 12 12h156q12 0 12-12v-17 M180 342v31m-10-10 10 10 10-10",
    className: "s16"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "docengine",
    transform: "translate(-385 335)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m682.24 56h4.59c1.26 0 2.29 1.03 2.29 2.29v10.31c0 1.27-1.03 2.29-2.29 2.29h-4.59c-1.26 0-2.29-1.02-2.29-2.29v-10.31c0-1.26 1.03-2.29 2.29-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m682.24 107.56h4.59c1.26 0 2.29 1.02 2.29 2.29v10.31c0 1.27-1.03 2.29-2.29 2.29h-4.59c-1.26 0-2.29-1.02-2.29-2.29v-10.31c0-1.27 1.03-2.29 2.29-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m653.6 84.64h10.31c1.27 0 2.29 1.03 2.29 2.29v4.59c0 1.26-1.02 2.29-2.29 2.29h-10.31c-1.26 0-2.29-1.03-2.29-2.29v-4.59c0-1.26 1.03-2.29 2.29-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m705.16 84.64h10.31c1.27 0 2.29 1.03 2.29 2.29v4.59c0 1.26-1.02 2.29-2.29 2.29h-10.31c-1.27 0-2.29-1.03-2.29-2.29v-4.59c0-1.26 1.02-2.29 2.29-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m706.41 64.11l3.24 3.24c0.9 0.9 0.9 2.35 0 3.24l-7.29 7.29c-0.9 0.9-2.35 0.9-3.24 0l-3.24-3.24c-0.9-0.89-0.9-2.34 0-3.24l7.29-7.29c0.89-0.89 2.35-0.89 3.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m669.95 100.57l3.24 3.24c0.9 0.89 0.9 2.34 0 3.24l-7.29 7.29c-0.89 0.9-2.34 0.9-3.24 0l-3.24-3.24c-0.89-0.89-0.89-2.35 0-3.24l7.29-7.29c0.9-0.9 2.35-0.9 3.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m665.9 64.11l7.29 7.29c0.9 0.9 0.9 2.35 0 3.24l-3.24 3.24c-0.89 0.9-2.34 0.9-3.24 0l-7.29-7.29c-0.89-0.89-0.89-2.34 0-3.24l3.24-3.24c0.9-0.89 2.35-0.89 3.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m702.36 100.57l7.29 7.29c0.9 0.89 0.9 2.35 0 3.24l-3.24 3.24c-0.89 0.9-2.35 0.9-3.24 0l-7.29-7.29c-0.9-0.9-0.9-2.35 0-3.24l3.24-3.24c0.89-0.9 2.34-0.9 3.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m684.54 113.29c-13.31 0-24.06-10.76-24.06-24.06 0-13.31 10.75-24.06 24.06-24.06 13.3 0 24.06 10.75 24.06 24.06 0 13.3-10.76 24.06-24.06 24.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m684.54 98.39c-5.07 0-9.17-4.1-9.17-9.16 0-5.07 4.1-9.17 9.17-9.17 5.06 0 9.16 4.1 9.16 9.17 0 5.06-4.1 9.16-9.16 9.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m449.64 81.35h226.85c15.18 0 27.57 9.51 27.66 21.24l0.76 95.58c0.09 11.73-12.15 21.24-27.34 21.24h-226.85c-15.18 0-27.57-9.51-27.66-21.24l-0.76-95.58c-0.09-11.73 12.15-21.24 27.34-21.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m483.29 188.95h26.45c8.1-1.3 10.28-4.04 11.13-11.49v-45.23c0.28-1.89-0.09-2.87-1.39-4.53l-13.92-14.27c-1.75-2.1-2.75-2.39-4.53-2.43h-34.79c-5.95 1.08-8.33 3.15-10.79 9.4v15.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m457.57 187.25c-8.04-7.74-10.67-11.09-10.57-15.09 0.14-5.29 2.85-8.72 10.57-15.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m480.81 137.9c6.43 6.19 8.53 8.88 8.45 12.08-0.11 4.23-2.28 6.97-8.45 12.06"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m543.19 117.86q1.17 0 2.02 1.04l22.29 29.97q0.55 0.64 0.55 1.48 0 1.19-0.84 1.83-0.83 0.64-1.68 0.64-1.19 0-1.97-1.03l-22.36-29.92q-0.54-0.69-0.54-1.48 0-1.09 0.8-1.81 0.78-0.72 1.73-0.72zm22.53 0.06q1 0 1.67 0.71 0.66 0.72 0.66 1.56 0 0.79-0.55 1.53l-10.37 13.89-2.82-3.9 9.44-12.6q0.85-1.19 1.97-1.19zm-22.88 34.9q-0.95 0-1.59-0.66-0.64-0.67-0.64-1.51 0-0.85 0.59-1.68l10.49-14.19 2.71 4-9.54 12.9q-0.79 1.14-2.02 1.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m593.03 118.02q2.61 0 4.84 1.41 2.22 1.4 3.56 3.83 1.33 2.42 1.33 5.44 0 3.01-1.33 5.45-1.34 2.46-3.56 3.91-2.23 1.46-4.84 1.46h-9.54l0.38-0.78v11.37q0 1.09-0.67 1.8-0.66 0.72-1.75 0.72-1.04 0-1.7-0.72-0.67-0.71-0.67-1.8v-29.57q0-1.09 0.74-1.81 0.75-0.71 1.78-0.71zm0 16.76q1.28 0 2.35-0.85 1.06-0.84 1.73-2.22 0.67-1.39 0.67-3.01 0-1.64-0.67-2.97-0.67-1.34-1.73-2.15-1.07-0.82-2.35-0.82h-9.64l0.5-0.73v13.39l-0.45-0.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m616.26 118.02h17.1q1.05 0 1.77 0.69 0.71 0.69 0.71 1.73 0 1.04-0.71 1.68-0.72 0.64-1.77 0.64h-14.93l0.5-0.84v11.08l-0.45-0.5h12.67q1.04 0 1.75 0.69 0.72 0.69 0.72 1.78 0 1.04-0.72 1.68-0.71 0.65-1.75 0.65h-12.56l0.34-0.45v11.43l-0.34-0.4h14.77q1.05 0 1.77 0.72 0.71 0.71 0.71 1.65 0 1.04-0.71 1.7-0.72 0.68-1.77 0.68h-17.1q-1.04 0-1.78-0.72-0.73-0.71-0.73-1.8v-29.57q0-1.09 0.73-1.81 0.74-0.71 1.78-0.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m649.88 152.63q-1.19 0-2.07-0.72-0.9-0.71-0.9-1.8v-29.57q0-1.09 0.74-1.81 0.75-0.71 1.78-0.71h13.95q2.68 0 4.89 1.3 2.23 1.31 3.59 3.61 1.35 2.31 1.35 5.27 0 1.98-0.78 3.79-0.79 1.79-2.12 3.19-1.35 1.38-3.02 2.07l-0.54-0.95q1.52 0.55 2.66 1.57 1.14 1.01 1.81 2.37 0.66 1.37 0.71 3.09 0.16 1.53 0.27 2.55 0.13 1.01 0.37 1.65 0.26 0.64 0.9 0.99 0.88 0.5 1.12 1.49 0.21 0.98-0.43 1.78-0.45 0.59-1.11 0.76-0.67 0.17-1.36 0.06-0.69-0.13-1.19-0.38-0.79-0.5-1.6-1.4-0.82-0.93-1.32-2.55-0.49-1.64-0.49-4.31 0-1.24-0.39-2.12-0.4-0.9-1.09-1.46-0.69-0.56-1.64-0.85-0.94-0.27-2.08-0.27h-10.47l0.69-0.98v11.82q0 1.09-0.6 1.8-0.59 0.72-1.63 0.72zm1.59-17.66h11.81q1.14-0.05 2.2-0.91 1.06-0.87 1.73-2.35 0.66-1.49 0.66-3.36 0-2.38-1.4-3.98-1.41-1.61-3.33-1.61h-11.58l0.55-1.28v14.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m546.67 161.88q2.14 0 3.78 0.8 1.62 0.8 2.72 2.22 1.09 1.42 1.66 3.28 0.55 1.85 0.55 3.93 0 2.83-0.99 5.15-1 2.33-2.93 3.7-1.92 1.37-4.79 1.37h-7.13q-0.62 0-1.05-0.42-0.44-0.43-0.44-1.07v-17.48q0-0.64 0.44-1.06 0.43-0.42 1.05-0.42zm-0.29 17.64q2.08 0 3.36-1.02 1.28-1.03 1.88-2.7 0.6-1.68 0.6-3.69 0-1.5-0.33-2.83-0.34-1.33-1.05-2.37-0.72-1.04-1.82-1.63-1.09-0.6-2.64-0.6h-5.53l0.27-0.27v15.41l-0.18-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m573.61 174.64q0 2.35-1.02 4.14-1.03 1.79-2.78 2.82-1.74 1.02-3.95 1.02-2.18 0-3.94-1.02-1.75-1.03-2.79-2.82-1.04-1.79-1.04-4.14 0-2.36 1.04-4.16 1.04-1.79 2.79-2.83 1.76-1.03 3.94-1.03 2.21 0 3.95 1.03 1.75 1.04 2.78 2.83 1.02 1.8 1.02 4.16zm-2.92 0q0-1.6-0.64-2.79-0.64-1.18-1.74-1.87-1.1-0.69-2.45-0.69-1.34 0-2.44 0.69-1.12 0.69-1.76 1.87-0.64 1.19-0.64 2.79 0 1.55 0.64 2.76 0.64 1.19 1.76 1.87 1.1 0.66 2.44 0.66 1.35 0 2.45-0.66 1.1-0.68 1.74-1.87 0.64-1.21 0.64-2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m583.73 166.62q1.57 0 2.8 0.33 1.23 0.33 1.91 0.93 0.69 0.6 0.69 1.39 0 0.5-0.29 0.92-0.3 0.42-0.87 0.42-0.41 0-0.69-0.14-0.29-0.15-0.52-0.36-0.23-0.2-0.59-0.41-0.32-0.17-0.94-0.28-0.63-0.13-1.13-0.13-1.55 0-2.66 0.71-1.13 0.7-1.76 1.9-0.63 1.19-0.63 2.72 0 1.51 0.63 2.71 0.63 1.21 1.72 1.9 1.1 0.7 2.56 0.7 0.87 0 1.43-0.13 0.55-0.12 0.96-0.33 0.44-0.27 0.75-0.55 0.3-0.27 0.87-0.27 0.64 0 0.97 0.39 0.33 0.39 0.33 0.98 0 0.64-0.76 1.24-0.79 0.61-2.07 0.98-1.29 0.38-2.83 0.38-2.28 0-3.97-1.05-1.67-1.05-2.6-2.87-0.92-1.8-0.92-4.08 0-2.31 0.98-4.11 0.96-1.79 2.68-2.84 1.72-1.05 3.95-1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m593.9 161.88h10.1q0.61 0 1.04 0.41 0.42 0.41 0.42 1.02 0 0.62-0.42 0.99-0.43 0.38-1.04 0.38h-8.82l0.29-0.5v6.55l-0.27-0.3h7.49q0.62 0 1.04 0.41 0.42 0.41 0.42 1.06 0 0.61-0.42 0.99-0.42 0.38-1.04 0.38h-7.42l0.2-0.26v6.74l-0.2-0.23h8.73q0.61 0 1.04 0.43 0.42 0.42 0.42 0.98 0 0.62-0.42 1-0.43 0.4-1.04 0.4h-10.1q-0.62 0-1.05-0.42-0.45-0.43-0.45-1.07v-17.48q0-0.64 0.45-1.06 0.43-0.42 1.05-0.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m616.69 166.62q2.08 0 3.21 0.85 1.14 0.86 1.59 2.31 0.45 1.45 0.45 3.23v7.83q0 0.64-0.42 1.07-0.42 0.42-1.04 0.42-0.64 0-1.05-0.42-0.41-0.43-0.41-1.07v-7.8q0-1.06-0.29-1.89-0.29-0.83-1-1.35-0.72-0.51-2.01-0.51-1.19 0-2.1 0.51-0.91 0.52-1.42 1.35-0.5 0.83-0.5 1.89v7.8q0 0.64-0.44 1.07-0.42 0.42-1.04 0.42-0.64 0-1.05-0.42-0.41-0.43-0.41-1.07v-12.39q0-0.64 0.41-1.07 0.41-0.42 1.05-0.42 0.62 0 1.04 0.42 0.44 0.43 0.44 1.07v1.64l-0.54 0.29q0.2-0.64 0.72-1.31 0.51-0.65 1.24-1.21 0.73-0.58 1.64-0.91 0.91-0.33 1.93-0.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m632.4 166.62q1.27 0 2.32 0.39 1.05 0.41 1.82 1.04 0.78 0.64 1.22 1.31 0.43 0.67 0.43 1.16l-0.66 0.04v-2.34q0-0.62 0.41-1.05 0.4-0.44 1.05-0.44 0.64 0 1.05 0.42 0.41 0.43 0.41 1.07v12.88q0 2.48-1.05 4.04-1.06 1.58-2.8 2.31-1.74 0.73-3.81 0.73-0.73 0-1.73-0.19-0.99-0.19-1.82-0.46-0.83-0.26-1.15-0.53-0.68-0.34-0.9-0.82-0.22-0.46-0.01-0.93 0.29-0.64 0.79-0.78 0.49-0.16 1.14 0.09 0.28 0.07 0.9 0.32 0.61 0.23 1.38 0.42 0.76 0.19 1.42 0.19 2.35 0 3.52-1.09 1.2-1.07 1.2-2.94v-2.64l0.32 0.2q-0.09 0.62-0.54 1.25-0.46 0.62-1.19 1.15-0.73 0.54-1.68 0.87-0.95 0.33-1.95 0.33-2.07 0-3.71-1.04-1.63-1.03-2.6-2.83-0.96-1.8-0.96-4.13 0-2.34 0.96-4.14 0.97-1.79 2.59-2.83 1.62-1.03 3.63-1.03zm0.45 2.67q-1.43 0-2.52 0.71-1.08 0.7-1.69 1.9-0.62 1.19-0.62 2.72 0 1.51 0.62 2.71 0.61 1.21 1.69 1.9 1.09 0.7 2.52 0.7 1.42 0 2.51-0.69 1.08-0.68 1.69-1.89 0.62-1.22 0.62-2.73 0-1.53-0.62-2.74-0.61-1.21-1.69-1.9-1.09-0.69-2.51-0.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m647.26 180.84q0 0.64-0.41 1.07-0.41 0.42-1.05 0.42-0.62 0-1.04-0.42-0.43-0.43-0.43-1.07v-12.51q0-0.64 0.43-1.06 0.42-0.42 1.04-0.42 0.64 0 1.05 0.42 0.41 0.42 0.41 1.06zm-1.5-15.93q-0.85 0-1.23-0.29-0.37-0.31-0.37-1.04v-0.47q0-0.73 0.41-1.03 0.41-0.29 1.23-0.29 0.87 0 1.25 0.3 0.37 0.31 0.37 1.02v0.47q0 0.75-0.38 1.05-0.4 0.28-1.28 0.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m659.12 166.62q2.07 0 3.21 0.85 1.14 0.86 1.59 2.31 0.46 1.45 0.46 3.23v7.83q0 0.64-0.42 1.07-0.43 0.42-1.04 0.42-0.64 0-1.05-0.42-0.41-0.43-0.41-1.07v-7.8q0-1.06-0.3-1.89-0.29-0.83-1.01-1.35-0.71-0.51-1.99-0.51-1.21 0-2.12 0.51-0.89 0.52-1.41 1.35-0.51 0.83-0.51 1.89v7.8q0 0.64-0.42 1.07-0.42 0.42-1.04 0.42-0.64 0-1.05-0.42-0.41-0.43-0.41-1.07v-12.39q0-0.64 0.41-1.07 0.41-0.42 1.05-0.42 0.62 0 1.04 0.42 0.42 0.43 0.42 1.07v1.64l-0.52 0.29q0.2-0.64 0.71-1.31 0.52-0.65 1.25-1.21 0.73-0.58 1.62-0.91 0.91-0.33 1.94-0.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m675.6 182.62q-2.42 0-4.2-1.01-1.8-1-2.77-2.77-0.99-1.78-0.99-4.05 0-2.57 1.04-4.4 1.04-1.83 2.72-2.8 1.66-0.97 3.53-0.97 1.42 0 2.72 0.56 1.28 0.57 2.29 1.57 1.01 1.02 1.59 2.37 0.58 1.36 0.61 2.97-0.03 0.58-0.46 0.96-0.44 0.39-1.03 0.39h-11.37l-0.7-2.49h10.99l-0.55 0.53v-0.73q-0.06-1.03-0.67-1.81-0.61-0.76-1.52-1.19-0.91-0.42-1.9-0.42-0.88 0-1.69 0.27-0.79 0.28-1.42 0.9-0.63 0.61-1 1.62-0.37 1-0.37 2.5 0 1.6 0.68 2.8 0.66 1.19 1.8 1.86 1.14 0.65 2.53 0.65 1.07 0 1.78-0.21 0.7-0.22 1.16-0.54 0.47-0.32 0.82-0.62 0.44-0.27 0.88-0.27 0.53 0 0.88 0.38 0.34 0.35 0.34 0.85 0 0.64-0.64 1.17-0.78 0.77-2.18 1.34-1.38 0.59-2.9 0.59z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m438.78 188.9h3.44c1.26 0 2.29 1.03 2.29 2.3v8.02c0 1.26-1.03 2.29-2.29 2.29h-3.44c-1.27 0-2.29-1.03-2.29-2.29v-8.02c0-1.27 1.02-2.3 2.29-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m438.78 231.3h3.44c1.26 0 2.29 1.02 2.29 2.29v8.02c0 1.26-1.03 2.29-2.29 2.29h-3.44c-1.27 0-2.29-1.03-2.29-2.29v-8.02c0-1.27 1.02-2.29 2.29-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m415.29 212.39h8.02c1.27 0 2.29 1.03 2.29 2.29v3.44c0 1.27-1.02 2.29-2.29 2.29h-8.02c-1.26 0-2.29-1.02-2.29-2.29v-3.44c0-1.26 1.03-2.29 2.29-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m457.68 212.39h8.02c1.27 0 2.29 1.03 2.29 2.29v3.44c0 1.27-1.02 2.29-2.29 2.29h-8.02c-1.26 0-2.29-1.02-2.29-2.29v-3.44c0-1.26 1.03-2.29 2.29-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m458.73 195.74l2.43 2.43c0.89 0.9 0.89 2.35 0 3.24l-5.67 5.67c-0.9 0.9-2.35 0.9-3.25 0l-2.43-2.43c-0.89-0.89-0.89-2.34 0-3.24l5.68-5.67c0.89-0.89 2.34-0.89 3.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m428.75 225.72l2.43 2.43c0.9 0.89 0.9 2.34 0 3.24l-5.67 5.67c-0.9 0.89-2.35 0.89-3.24 0l-2.43-2.43c-0.9-0.9-0.9-2.35 0-3.24l5.67-5.67c0.89-0.9 2.35-0.9 3.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m425.51 195.74l5.67 5.67c0.9 0.9 0.9 2.35 0 3.24l-2.43 2.43c-0.89 0.9-2.35 0.9-3.24 0l-5.67-5.67c-0.9-0.89-0.9-2.34 0-3.24l2.43-2.43c0.89-0.89 2.34-0.89 3.24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m455.49 225.72l5.67 5.67c0.89 0.89 0.89 2.34 0 3.24l-2.43 2.43c-0.9 0.89-2.35 0.89-3.24 0l-5.68-5.67c-0.89-0.9-0.89-2.35 0-3.24l2.43-2.43c0.9-0.9 2.35-0.9 3.25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m440.5 235.88c-10.77 0-19.48-8.71-19.48-19.48 0-10.77 8.71-19.48 19.48-19.48 10.77 0 19.47 8.71 19.47 19.48 0 10.77-8.7 19.48-19.47 19.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m440.5 223.85c-4.12 0-7.45-3.33-7.45-7.45 0-4.12 3.33-7.45 7.45-7.45 4.12 0 7.44 3.33 7.44 7.45 0 4.12-3.32 7.45-7.44 7.45z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 590v40m-10-10 10 10 10-10",
    className: "s16"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "accessible-documents",
    transform: "translate(-660 575)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m815.81 124.7l75.82-5.31c5.51-0.38 10.28 3.77 10.67 9.28l5.51 78.81c0.39 5.51-3.77 10.29-9.28 10.67l-75.81 5.3c-5.51 0.39-10.29-3.76-10.68-9.27l-5.51-78.81c-0.38-5.51 3.77-10.29 9.28-10.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m825.54 149.08l58.85-4.12m-57.81 19.08l44.89-3.14m-43.84 18.1l53.87-3.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m837.94 190.31l40.9-2.86c6.34-0.44 11.83 4.34 12.28 10.67 0.44 6.34-4.34 11.83-10.67 12.28l-40.9 2.86c-6.34 0.44-11.83-4.34-12.28-10.67-0.44-6.34 4.34-11.84 10.67-12.28z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "HTML",
    transform: "matrix(.998 -.07 .07 .998 842.445 206.11)",
    x: 0,
    y: 0,
    fontFamily: "DMSans, Arial, sans-serif",
    fontSize: 13,
    fill: "#45556d"
  }, "HTML")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m788.79 77.48l75.81 5.3c5.51 0.39 9.67 5.16 9.28 10.67l-6.14 87.79c-0.38 5.51-5.16 9.66-10.67 9.28l-75.81-5.3c-5.51-0.39-9.67-5.17-9.28-10.68l6.14-87.78c0.38-5.51 5.16-9.67 10.67-9.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m795.95 104.04l57.86 4.05m-58.9 10.92l43.89 3.07m-44.94 11.89l52.87 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m800.16 151.45l44.89 3.14c6.88 0.48 12.08 6.46 11.6 13.34-0.49 6.89-6.46 12.08-13.35 11.6l-44.89-3.14c-6.88-0.48-12.08-6.45-11.59-13.34 0.48-6.89 6.45-12.08 13.34-11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m795.83 163.18l4.64 5.33 8.68-9.41"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PDF-UA",
    transform: "matrix(.911 .064 -.064 .911 810.259 168.941)",
    x: 0,
    y: 0,
    fontFamily: "DMSans, Arial, sans-serif",
    fontSize: 12,
    fill: "#357653"
  }, "PDF/UA")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 813v17 M90 860v-18q0-12 12-12h156q12 0 12 12v68 M80 850l10 10 10-10 M260 900l10 10 10-10",
    className: "s16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "website-output",
    transform: "translate(-967 846)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m1039 125h36m-18-15v15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m1010 32h94c6.08 0 11 4.92 11 11v56c0 6.08-4.92 11-11 11h-94c-6.08 0-11-4.92-11-11v-56c0-6.08 4.92-11 11-11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m1015 42h84c3.31 0 6 2.69 6 6v40c0 3.31-2.69 6-6 6h-84c-3.31 0-6-2.69-6-6v-40c0-3.31 2.69-6 6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m1020 54c-1.66 0-3-1.34-3-3 0-1.66 1.34-3 3-3 1.66 0 3 1.34 3 3 0 1.66-1.34 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m1030 54c-1.66 0-3-1.34-3-3 0-1.66 1.34-3 3-3 1.66 0 3 1.34 3 3 0 1.66-1.34 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m1020 66h55m-55 11h39"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Website ",
    transform: "translate(1057,147)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.9,
    y: 0,
    className: "t3"
  }, "Website\n")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "printer-output",
    transform: "translate(-888 820)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m1135 109h46c3.87 0 7 3.13 7 7v41c0 3.87-3.13 7-7 7h-46c-3.87 0-7-3.13-7-7v-41c0-3.87 3.13-7 7-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m1140 125h36m-36 12h29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m1127 144h62c6.63 0 12 5.37 12 12v31c0 6.63-5.37 12-12 12h-62c-6.63 0-12-5.37-12-12v-31c0-6.63 5.37-12 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m1135 169h46c3.87 0 7 3.13 7 7v29c0 3.87-3.13 7-7 7h-46c-3.87 0-7-3.13-7-7v-29c0-3.87 3.13-7 7-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m1140 184h36m-36 12h27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m1188 162c-2.21 0-4-1.79-4-4 0-2.21 1.79-4 4-4 2.21 0 4 1.79 4 4 0 2.21-1.79 4-4 4z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Printer ",
    transform: "translate(1158,232)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.6,
    y: 0,
    className: "t3"
  }, "Printer\n")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "email-output",
    transform: "translate(-925 839)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m1011 177h67c6.63 0 12 5.37 12 12v42c0 6.63-5.37 12-12 12h-67c-6.63 0-12-5.37-12-12v-42c0-6.63 5.37-12 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m1009 232l25-23m45 23l-25-23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m1009 189l35 27 35-27"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Email ",
    transform: "translate(1044.5,263)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18,
    y: 0,
    className: "t3"
  }, "Email\n")))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "sms-output",
    transform: "translate(-870 819)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m1111.14 253.72l58 0.58c7.73 0.07 13.93 6.4 13.85 14.13l-0.26 26c-0.07 7.74-6.4 13.94-14.13 13.86l-58-0.57c-7.73-0.08-13.93-6.42-13.86-14.15l0.26-25.99c0.08-7.73 6.4-13.93 14.14-13.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m1116.95 272.78l46 0.46m-46.14 13.54l32 0.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m1113.63 304.75l-8.15 14.92 22.13-11.78"
  }), /*#__PURE__*/React.createElement("text", {
    id: "SMS ",
    transform: "translate(1140,329)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.9,
    y: 0,
    className: "t3"
  }, "SMS\n"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocengineIllustrationVerticle);
export default __webpack_public_path__ + "static/media/docengine_illustration_verticle.15c75413ae80ed7d2f68283046022516.svg";
export { ForwardRef as ReactComponent };